define(['exports', 'react', 'classnames', './styles/Button.css'], function (exports, _react, _classnames) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Button = function Button(_ref) {
    var label = _ref.label,
        type = _ref.type,
        disabled = _ref.disabled,
        icon = _ref.icon,
        buttonStyle = _ref.buttonStyle,
        labelStyle = _ref.labelStyle,
        onClick = _ref.onClick;

    var buttonClasses = (0, _classnames2.default)('button rounded', {
      'button-primary': type === 'primary',
      'button-secondary': type === 'secondary',
      'button-disabled': disabled
    });
    var buttonContainerClasses = (0, _classnames2.default)('button-container rounded', {
      'button-container-disabled': disabled
    });

    return _react2.default.createElement(
      'div',
      { className: buttonContainerClasses },
      _react2.default.createElement(
        'button',
        {
          disabled: disabled,
          className: buttonClasses,
          style: buttonStyle,
          onClick: onClick },
        _react2.default.createElement(
          'div',
          { className: 'flex items-center justify-center' },
          _react2.default.createElement(
            'div',
            { className: 'mr1' },
            icon
          ),
          _react2.default.createElement(
            'div',
            { className: 'nunito-font button-label', style: labelStyle },
            label
          )
        )
      )
    );
  };

  exports.default = Button;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/common/Button.js
// module id = 130
// module chunks = 0